const TSE_API = `${import.meta.env.VITE_APP_TSE_API}api/v2`;

export { TSE_API };
